// composables/useApiFetchPage.ts
import { getApiFetchConfig, handlePending, handleError } from './useApiFetchBase'
import { refreshAuthToken } from './../auth/useAuthRefresh'
import type { UseFetchOptions } from '#app'

export const useApiFetchPage = async <T>(
  url: string,
  options: UseFetchOptions<T[], unknown> = {},
  api: 'api1' | 'api2' = 'api1'
) => {
  type ApiResponse<T> = {
    success: boolean;
    message: string;
    data: {
      totalRecords: number;
      pageSize: number;
      currentPage: number;
      totalPages: number;
      records:  T[];
    } | null;
  };

  const router = useRouter()
  const route = useRoute()
  const refreshToken = useCookie<string | null>('iqa-refresh-token')
  const tokenExp = useCookie<number | null>('iqa-token-exp') || ref(0)

  const isLogin = (import.meta.client &&
    (route.path !== '/login' &&
      route.path !== '/selectTenant' &&
      route.path !== '/customers' &&
      route.path !== '/resetPassword')) ? false : true;

  const emptyPageResponse = () => ({
    data: {
      totalRecords: 0,
      pageSize: 0,
      currentPage: 1,
      totalPages: 1,
      records: [] as T[],
    }
  });

  // PRE-CHECK antes de cualquier request
  if (!isLogin && (!refreshToken.value || !tokenExp.value))
  {
    useAuthStore().logout()
    await nextTick()
    await redirectToLoginIfNeeded();

    return emptyPageResponse()
  }

  const NOW = Date.now()
  const SAFE_MARGIN = 2 * 60 * 1000
  if (!isLogin && (NOW + SAFE_MARGIN >= (tokenExp.value ?? 0)))
  {
    try {
      await refreshAuthToken();
    } catch (e) {
      // si falla el refresh → logout directo
      useAuthStore().logout()
      await nextTick()
      await redirectToLoginIfNeeded();

      return emptyPageResponse()
    }
  }

  const { baseURL, headers } = getApiFetchConfig(options, api);
  const finalUrl = `${baseURL}${url}`;

  const pending = ref(false)
  const error = ref<Error | null>(null)
  // Construir el objeto final para $fetch
  const param2 = {
    method: 'GET' as const,  // o 'POST', 'PUT', etc.
    headers: headers as Record<string, string>,
    params:options.params,
  };


  try {
    pending.value = true
    error.value = null
    const response = await $fetch<ApiResponse<T>>(finalUrl, param2);

    const normalized = {
      totalRecords: response.data?.totalRecords ?? 0,
      pageSize: response.data?.pageSize ?? 0,
      currentPage: response.data?.currentPage ?? 1,
      totalPages: response.data?.totalPages ?? 1,
      records: response.data?.records ?? [],
    };

    return { data: normalized };
  }

  catch(err: any)
  {

    const errorStatus = err?.statusCode ?? err?.status ?? err?.response?.status;

    if (errorStatus === 401)
    {
      useAuthStore().logout();
      await nextTick();
      await redirectToLoginIfNeeded();

      return emptyPageResponse()
    }

    //error.value = err
    //handleFatalError("Hubo un problema interno. Por favor, intentar de nuevo."); //No usar await
    //redirectToLoginIfNeeded(); //No usar await
    //No usar await, porque en caso de que a nivel de componente se levanta un modal, bloquea la acción de dar click del sweet alert,
      //porque el focus del modal bloquea el sweet alert, A PESAR, de que el sweet alert se muestre encima del modal.

    return emptyPageResponse()
  }
  finally {
    pending.value = false;
    swal_close();
  }
};